import React, { FC, memo } from 'react';

import logo from '@assets/logos/logo.svg?url';

import Explore from './Explore';
import Header from './Header';
import useStyles from './styles.module';

interface Props {
  onClose: () => void;
}

const MobileMenu: FC<Props> = ({ onClose }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Header onClose={onClose} />
      <div className={classes.wrap}>
        <Explore onClose={onClose} />
        <img src={logo} alt="" className={classes.logo} />
      </div>
    </div>
  );
};

export default memo(MobileMenu);
